import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-dropdown-radio',
  templateUrl: './dropdown-radio.component.html',
  styleUrls: ['./dropdown-radio.component.css']
})
export class DropdownRadioComponent implements OnInit {
  @Input() options: { value: any, text: string }[] = [];
  @Output() optionSelected = new EventEmitter<number>();

  dropdownId: string;
  dropdownButtonId: string;
  selectedText: string = '';
  isDropdownOpen: boolean = false;
  constructor(
    private elementRef: ElementRef
  ) {
    this.selectedText = 'Today';

  }
  ngOnInit(): void {
    initFlowbite();
    const uniqueId = Math.random().toString(36).substring(2, 15);
    this.dropdownId = `dropdown_${uniqueId}`;
    this.dropdownButtonId = `dropdownButton_${uniqueId}`;
  }

  /**
   * Selects an option from the dropdown, updates the selected text, emits the selected value, and closes the dropdown.
   * @param selectedValue - The value of the selected option.
   * @param selectedText - The display text of the selected option.
   */
  selectOption(selectedValue: number, selectedText: string): void {
    this.selectedText = selectedText;
    this.optionSelected.emit(selectedValue);
    this.closeDropdown();
  }

  /**
   * Toggle the dropdown menu.
   * If the dropdown is open, this function will close it.
   * If the dropdown is closed, this function will open it.
   */
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
   * Closes the dropdown if it is open.
   */
  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  /**
 * Close the dropdown when a click is registered outside the component.
 * @param event the click event
 */
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }
}
